<template>
  <ActionDelete :disabled="disabled" btn-classes="btn-danger" btn-classes-mobile="text-danger" :show-icons-only="showIconsOnly" @click.prevent="$emit('click', $event)" />
</template>

<script>

export default {
  components: {
    ActionDelete: () => import('@/libs/Table/components/Actions/ActionDelete'),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    showIconsOnly: {
      type: Boolean,
      default: false,
    },
  },
};

</script>
